/* =========================================================
   MAGICLOOPS CROSS SELL
   Ranking + Varianten-Modal + Add to Cart
   ========================================================= */

let crossSellProduct = null;
let crossSellSelectedVariant = null;
let crossSellQuantity = 1;


/* =========================================================
   BASIS
   ========================================================= */

function getCrossSellModal() {
  return document.querySelector('[data-cross-sell-modal]');
}

function crossSellShopRoot() {
  return window.Shopify?.routes?.root || '/';
}

function formatCrossSellPrice(cents) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(Number(cents) / 100);
}


/* =========================================================
   SMART CROSS-SELL RANKING
   ========================================================= */

function initialiseCrossSellRanking() {
  try {
    const roots = document.querySelectorAll('[data-cross-sell-root]');

    roots.forEach((root) => {
      const output = root.querySelector('[data-cross-sell-products]');
      const candidates = root.querySelectorAll(
        '[data-cross-sell-candidate]'
      );

      if (!output) return;

      /*
       * Wenn keine Ranking-Kandidaten vorhanden sind,
       * lassen wir einfach den Liquid-Fallback stehen.
       */
      if (!candidates.length) {
        root.hidden = false;
        return;
      }

      const products = new Map();

      candidates.forEach((candidate, index) => {
        const productKey =
          candidate.dataset.productKey ||
          candidate.dataset.productId;

        const score = Number(candidate.dataset.score || 0);

        if (!productKey) return;

        const card = candidate.querySelector(
          '.cart-cross-sell__product'
        );

        if (!card) return;

        /*
         * Erstes Auftreten des Produkts merken
         */
        if (!products.has(productKey)) {
          products.set(productKey, {
            key: productKey,
            score: 0,
            firstSeen: index,
            card: card.cloneNode(true)
          });
        }

        /*
         * Punkte aus mehreren Warenkorbprodukten addieren
         */
        products.get(productKey).score += score;
      });

      const rankedProducts = [...products.values()].sort(
        (a, b) => {
          if (b.score !== a.score) {
            return b.score - a.score;
          }

          return a.firstSeen - b.firstSeen;
        }
      );

      /*
       * Nur ersetzen, wenn das Ranking wirklich
       * Produkte gefunden hat.
       *
       * Sonst bleibt der Liquid-Fallback sichtbar.
       */
      if (rankedProducts.length > 0) {
        output.innerHTML = '';

        rankedProducts.forEach((product) => {
          product.card.dataset.crossSellScore =
            product.score;

          output.appendChild(product.card);
        });
      }

      root.hidden = false;
    });
  } catch (error) {
    /*
     * Ganz wichtig:
     * Ein Ranking-Fehler darf niemals Modal oder
     * Add-to-Cart lahmlegen.
     */
    console.error('Cross-Sell Ranking Fehler:', error);

    document
      .querySelectorAll('[data-cross-sell-root]')
      .forEach((root) => {
        root.hidden = false;
      });
  }
}


/* =========================================================
   MENGE IM MODAL
   ========================================================= */

function updateCrossSellQuantity() {
  const modal = getCrossSellModal();

  if (!modal) return;

  const quantityDisplay = modal.querySelector(
    '[data-cross-sell-qty]'
  );

  if (quantityDisplay) {
    quantityDisplay.textContent = crossSellQuantity;
  }
}


/* =========================================================
   AUSGEWÄHLTE VARIANTE
   ========================================================= */

function updateCrossSellSelectedVariant(product, variant) {
  const modal = getCrossSellModal();

  if (!modal || !variant) return;

  crossSellSelectedVariant = variant;

  const price = modal.querySelector(
    '[data-cross-sell-modal-price]'
  );

  if (price) {
    price.textContent = formatCrossSellPrice(
      variant.price
    );
  }

  const image = modal.querySelector(
    '[data-cross-sell-modal-image]'
  );

  const imageSource =
    variant.featured_image?.src ||
    product.featured_image ||
    product.images?.[0];

  if (image && imageSource) {
    image.src = imageSource;

    image.alt =
      variant.public_title ||
      variant.title ||
      product.title;
  }

  /*
   * Aktive Farbkachel markieren
   */
  modal
    .querySelectorAll('[data-cross-sell-variant]')
    .forEach((button) => {
      const isSelected =
        Number(button.dataset.crossSellVariant) ===
        Number(variant.id);

      button.setAttribute(
        'aria-pressed',
        String(isSelected)
      );
    });

  /*
   * Add-Button je nach Verfügbarkeit
   */
  const addButton = modal.querySelector(
    '[data-cross-sell-modal-add]'
  );

  if (addButton) {
    addButton.disabled = !variant.available;

    addButton.textContent = variant.available
      ? 'In den Warenkorb legen'
      : 'Nicht verfügbar';
  }
}


/* =========================================================
   VARIANTENKACHELN ERZEUGEN
   ========================================================= */

function buildCrossSellVariants(product) {
  const modal = getCrossSellModal();

  if (!modal) return;

  const container = modal.querySelector(
    '[data-cross-sell-modal-variants]'
  );

  if (!container) return;

  container.innerHTML = '';

  product.variants.forEach((variant) => {
    const button = document.createElement('button');

    button.type = 'button';

    button.className =
      'cart-cross-sell-modal__variant';

    button.dataset.crossSellVariant = variant.id;

    button.setAttribute(
      'aria-pressed',
      'false'
    );

    const variantName =
      variant.public_title ||
      variant.title ||
      variant.option1 ||
      'Variante';

    button.setAttribute(
      'aria-label',
      variantName
    );

    const imageSource =
      variant.featured_image?.src ||
      product.featured_image ||
      product.images?.[0];

    if (imageSource) {
      const image = document.createElement('img');

      image.src = imageSource;
      image.alt = variantName;
      image.loading = 'lazy';

      button.appendChild(image);
    } else {
      const label = document.createElement('span');

      label.className =
        'cart-cross-sell-modal__variant-label';

      label.textContent = variantName;

      button.appendChild(label);
    }

    if (!variant.available) {
      button.classList.add(
        'cart-cross-sell-modal__variant--sold-out'
      );
    }

    button.addEventListener('click', () => {
      updateCrossSellSelectedVariant(
        product,
        variant
      );
    });

    container.appendChild(button);
  });

  /*
   * Erste verfügbare Variante vorauswählen
   */
  const firstAvailable =
    product.variants.find(
      (variant) => variant.available
    ) || product.variants[0];

  if (firstAvailable) {
    updateCrossSellSelectedVariant(
      product,
      firstAvailable
    );
  }
}


/* =========================================================
   MODAL ÖFFNEN
   ========================================================= */

async function openCrossSellModal(handle) {
  const modal = getCrossSellModal();

  if (!modal || !handle) {
    console.error(
      'Modal oder Produkt-Handle fehlt.'
    );

    return;
  }

  const title = modal.querySelector(
    '[data-cross-sell-modal-title]'
  );

  const variants = modal.querySelector(
    '[data-cross-sell-modal-variants]'
  );

  const price = modal.querySelector(
    '[data-cross-sell-modal-price]'
  );

  if (title) {
    title.textContent = 'Wird geladen …';
  }

  if (price) {
    price.textContent = '';
  }

  if (variants) {
    variants.innerHTML = '';
  }

  crossSellQuantity = 1;
  crossSellSelectedVariant = null;

  updateCrossSellQuantity();

  /*
   * Modal sofort anzeigen.
   * So reagiert der Button ohne Verzögerung.
   */
  if (!modal.open) {
  modal.showModal();
}

  try {
    const response = await fetch(
      crossSellShopRoot() +
        'products/' +
        encodeURIComponent(handle) +
        '.js',
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Produkt konnte nicht geladen werden.'
      );
    }

    crossSellProduct =
      await response.json();

    if (title) {
      title.textContent =
        crossSellProduct.title;
    }

    buildCrossSellVariants(
      crossSellProduct
    );
  } catch (error) {
    console.error(
      'Cross-Sell Produktfehler:',
      error
    );

    if (title) {
      title.textContent =
        'Produkt konnte nicht geladen werden.';
    }
  }
}


/* =========================================================
   MODAL SCHLIESSEN
   ========================================================= */

function closeCrossSellModal() {
  const modal = getCrossSellModal();

  if (!modal) return;

if (modal.open) {
  modal.close();
}

  crossSellProduct = null;
  crossSellSelectedVariant = null;
  crossSellQuantity = 1;
}


/* =========================================================
   PRODUKT VIA SHOPIFY AJAX HINZUFÜGEN
   ========================================================= */

async function addCrossSellVariant(
  variantId,
  quantity = 1
) {
  const response = await fetch(
    crossSellShopRoot() + 'cart/add.js',
    {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity)
          }
        ]
      })
    }
  );

  if (!response.ok) {
    const responseData =
      await response.json().catch(() => null);

    throw new Error(
      responseData?.description ||
        'Produkt konnte nicht hinzugefügt werden.'
    );
  }

  return response.json();
}


/* =========================================================
   HORIZON WARENKORB INFORMIEREN
   ========================================================= */

function notifyCrossSellCart(quantity) {
  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,

      detail: {
        data: {
          itemCount: quantity,
          source: 'product-form-component'
        }
      }
    })
  );
}


/* =========================================================
   ALLE KLICKS
   Event Delegation = funktioniert auch nach Ranking/Cloning
   ========================================================= */

document.addEventListener(
  'click',
  async (event) => {

    /*
     * Produktkarte:
     * In den Warenkorb legen
     */
    const productButton =
      event.target.closest(
        '[data-cross-sell-add]'
      );

    if (productButton) {
      event.preventDefault();
      event.stopPropagation();

      if (productButton.disabled) {
        return;
      }

      const hasVariants =
        productButton.dataset.hasVariants ===
        'true';

      const handle =
        productButton.dataset.productHandle;

      const variantId =
        productButton.dataset.variantId;

      /*
       * Mehrere Varianten:
       * Modal öffnen
       */
      if (hasVariants) {
        await openCrossSellModal(handle);

        return;
      }

      /*
       * Nur eine Variante:
       * Direkt hinzufügen
       */
      productButton.disabled = true;

      const oldHTML =
        productButton.innerHTML;

      productButton.innerHTML =
        '<span>Wird hinzugefügt …</span>';

      try {
        await addCrossSellVariant(
          variantId,
          1
        );

        notifyCrossSellCart(1);

        productButton.innerHTML =
          '<span>✓ Hinzugefügt</span>';

        setTimeout(() => {
          productButton.innerHTML =
            oldHTML;

          productButton.disabled =
            false;
        }, 1000);
      } catch (error) {
        console.error(
          'Cross-Sell Add Fehler:',
          error
        );

        productButton.innerHTML =
          '<span>Bitte erneut versuchen</span>';

        setTimeout(() => {
          productButton.innerHTML =
            oldHTML;

          productButton.disabled =
            false;
        }, 1500);
      }

      return;
    }


    /*
     * Modal schließen
     */
    if (
      event.target.closest(
        '[data-cross-sell-modal-close]'
      )
    ) {
      closeCrossSellModal();

      return;
    }


    /*
     * Menge minus
     */
    if (
      event.target.closest(
        '[data-cross-sell-qty-minus]'
      )
    ) {
      crossSellQuantity = Math.max(
        1,
        crossSellQuantity - 1
      );

      updateCrossSellQuantity();

      return;
    }


    /*
     * Menge plus
     */
    if (
      event.target.closest(
        '[data-cross-sell-qty-plus]'
      )
    ) {
      crossSellQuantity += 1;

      updateCrossSellQuantity();

      return;
    }


    /*
     * Modal:
     * ausgewählte Variante hinzufügen
     */
    const modalAddButton =
      event.target.closest(
        '[data-cross-sell-modal-add]'
      );

    if (modalAddButton) {
      if (
        !crossSellSelectedVariant ||
        !crossSellSelectedVariant.available
      ) {
        return;
      }

      modalAddButton.disabled = true;

      const oldText =
        modalAddButton.textContent;

      modalAddButton.textContent =
        'Wird hinzugefügt …';

      try {
        await addCrossSellVariant(
          crossSellSelectedVariant.id,
          crossSellQuantity
        );

        notifyCrossSellCart(
          crossSellQuantity
        );

        modalAddButton.textContent =
          '✓ Hinzugefügt';

        setTimeout(() => {
          closeCrossSellModal();

          modalAddButton.textContent =
            oldText;

          modalAddButton.disabled =
            false;
        }, 650);
      } catch (error) {
        console.error(
          'Cross-Sell Modal Add Fehler:',
          error
        );

        modalAddButton.textContent =
          'Bitte erneut versuchen';

        setTimeout(() => {
          modalAddButton.textContent =
            oldText;

          modalAddButton.disabled =
            false;
        }, 1500);
      }
    }
  }
);


/* =========================================================
   ESC = MODAL SCHLIESSEN
   ========================================================= */

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Escape') {
      closeCrossSellModal();
    }
  }
);


/* =========================================================
   RANKING INITIALISIEREN
   Erst NACHDEM alle anderen Funktionen registriert sind.
   ========================================================= */

function startCrossSellRanking() {
  initialiseCrossSellRanking();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    startCrossSellRanking
  );
} else {
  startCrossSellRanking();
}


/* =========================================================
   CART UPDATE
   ========================================================= */

document.addEventListener(
  'cart:update',
  () => {
    window.setTimeout(
      initialiseCrossSellRanking,
      250
    );
  }
);


/* =========================================================
   HORIZON DYNAMISCHE NEURENDERINGS
   ========================================================= */

let crossSellRankingTimer;

const crossSellObserver =
  new MutationObserver((mutations) => {
    let newCrossSellRootFound = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(
        (node) => {
          if (
            !(node instanceof HTMLElement)
          ) {
            return;
          }

          if (
            node.matches?.(
              '[data-cross-sell-root]'
            ) ||
            node.querySelector?.(
              '[data-cross-sell-root]'
            )
          ) {
            newCrossSellRootFound =
              true;
          }
        }
      );
    });

    if (!newCrossSellRootFound) {
      return;
    }

    window.clearTimeout(
      crossSellRankingTimer
    );

    crossSellRankingTimer =
      window.setTimeout(() => {
        initialiseCrossSellRanking();
      }, 100);
  });

if (document.body) {
  crossSellObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
}